
import './CloudianryConnect.css';
import hero from './assets/hero.jpg'
import InfoIcon from './assets/info.svg'
import {useContext} from "react";
import {AppContext} from "./AppContext";
import {default as Loading} from './AppLoading';
import {useToast} from "@shopify/app-bridge-react";


export default function CloudinaryConnect(props) {
    let {serverCaller, cldStatus, setCldStatus, shopifyState, backendUrl, connectionError} = useContext(AppContext);
    const {show} = useToast()

    async function handleOnClick() {
        try {
            const ret = await serverCaller(backendUrl + "/cld-auth", {
                headers: {
                    'Content-Type': 'application/json',
                },
                withCredentials: true,
                method: 'post'
            })
            if (ret.status === 200) {
                let jsonRet = await ret.data;
                window.addEventListener("message", (event) => {
                    if (event.origin !== window.location.origin) {
                        return;
                    }
                    if (event.data === 'refresh') {
                        setCldStatus('get')
                    }
                }, false);

                const url = `${backendUrl}/cld-auth/auth?nonce=${jsonRet.nonce}&shop=${props.shop}&redirectTo=${window.location.origin}?close=true`
                window.open(url, '_blank', 'location=yes,height=770,width=620,scrollbars=yes,status=yes');
            } else {
                show('Error getting nonce', {error: true})
            }
        } catch (e) {
            show('Error getting nonce', {error: true})
        }
    }
    const showLoading  =  cldStatus == null
    const showCldContent = (cldStatus === false && shopifyState === true)

    return (
        <>
            {showLoading && <Loading error={connectionError}/> }
            {showCldContent && <>
                <div className={'wrap'}>
                    <div className={'hero'}>
                        <img alt={'hero'} src={hero}/>
                    </div>
                    <div className={'text'}>
                        <h4>Unleash the Full Potential of your Product Media</h4>
                        <div className={'cld-desc'}>
                            <p>Transform images and videos to load faster with no visual degradation,
                                <br/>
                                automatically generate image and video variants, and deliver high quality responsive experiences to increase conversions.
                               </p>
                        </div>
                        <a className={'signup'} target={'_blank'} rel="noopener noreferrer"
                           href={'https://cloudinary.com/users/register/free'}>Sign up for Cloudinary</a>
                        <div>
                            <button className={'cld-connect'} onClick={handleOnClick} > Connect to Cloudinary</button>
                        </div>
                    </div>
                </div>
                <div className={'cld-info'}><img src={InfoIcon} alt=""/> Learn more about <a href={'https://cloudinary.com/documentation'}  rel="noopener noreferrer" target={'_blank'}>Cloudinary</a></div>
                </>
            }
        </>
    )
}